import { Box, Typography } from '@mui/material';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function OptionChipGroup({
  options = [],
  value,
  onChange,
  disabled = false,
  variant = 'chip',
  sx,
}) {
  const styles = useTemplateSx();
  const isCard = variant === 'card';

  return (
    <Box
      sx={{
        ...(isCard ? styles.formOptionCards : styles.optionPicker.root),
        ...sx,
      }}
    >
      {options.map((option) => {
        const selected = value === option.value;
        const Icon = option.icon;
        const baseSx = isCard ? styles.formOptionCard : styles.optionPicker.chip;
        const selectedSx = isCard
          ? styles.formOptionCardSelected
          : styles.optionPicker.chipSelected;

        return (
          <Box
            key={option.value}
            component="button"
            type="button"
            disabled={disabled || option.disabled}
            onClick={() => onChange?.(option.value)}
            sx={{
              ...baseSx,
              ...(selected ? selectedSx : {}),
              ...(disabled || option.disabled
                ? { opacity: 0.55, cursor: 'not-allowed' }
                : {}),
            }}
          >
            {Icon ? (
              <Icon
                sx={{
                  fontSize: isCard ? 22 : 16,
                  mb: isCard ? 0.5 : 0,
                  color: selected && !isCard ? 'inherit' : selected ? 'primary.main' : 'text.secondary',
                }}
              />
            ) : null}
            <Typography
              component="span"
              sx={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                lineHeight: 1.2,
                color: 'inherit',
              }}
            >
              {option.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
